/**
 * One row of the sidebar, whether it is a link or a group's disclosure header —
 * the same box, the same focus ring, the same two tones, so an operator cannot
 * tell from the shape which one they are looking at until the chevron says so.
 * Logical sides only (U7): the rail sits on the right in Arabic.
 */
export const SIDEBAR_NAV_ROW_CLASSES =
  'flex w-full items-center gap-md rounded-md px-md py-sm text-label transition-colors duration-fast ease-standard focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-card';

export const SIDEBAR_NAV_ROW_ACTIVE_CLASSES = 'bg-primary/10 font-medium text-primary';

export const SIDEBAR_NAV_ROW_IDLE_CLASSES =
  'text-muted-foreground hover:bg-secondary hover:text-foreground';

/**
 * A closed group whose child is the current page: the operator is "in" it, so
 * it reads as located, but it is not itself a page, so it does not take the
 * link's primary tint.
 */
export const SIDEBAR_NAV_ROW_LOCATED_CLASSES = 'font-medium text-foreground hover:bg-secondary';

/** The nested list: a hairline on the inline start ties the children to their header. */
export const SIDEBAR_NAV_CHILDREN_CLASSES =
  'ms-lg mt-xs flex flex-col gap-xs border-s border-border ps-sm';
